// import React from "react";
// import Sidebar from "../../components/Super Admin/SideBar/Sidebar";
// import Topbar from '../../components/Super Admin/TopBar/TopbarLeadManagement'
// import ParentList from "../../components/Super Admin/Lead Management/ParentList";
// // import "./../styles/parentlist.css";

// const ParentListPage: React.FC = () => {
//   return (
//     <>
//         <Topbar />
//         <ParentList />
//   </>
//   );
// };

// export default ParentListPage;





import React from "react";
import NotificationManagement from "../../components/Super Admin/Lead Management";

// Keeps the existing /parent-list route and PrivateRoute permission unchanged.
const ParentListPage: React.FC = () => <NotificationManagement />;

export default ParentListPage;
